import styled from 'styled-components';

export const TableStyle = styled.div`
  width: 100%;
  margin-left: 50px;
  margin-bottom: 20px;
  .ant-table-thead > tr > th {
    background: #f0f0f0;
  }
  .ant-table {
    background: #e8e8e8;
  }
`;

export const TableSecStyle = styled.div`
  /* margin-left: 100px; */
`;
